// Vocabulario compartido de insumos. Las claves son las del backend, no las traducidas:
// `supply.category` sólo vale 'cafeteria' | 'cleaning' | 'packaging' | 'other'
// (SupplyController.VALID_CATEGORIES) y `base_unit` sólo 'g' | 'ml' | 'unit'. Traducir con
// claves inventadas ('limpieza', 'otros') hace que el fallback imprima el enum en inglés.
export const UNIT_LABELS = { g: 'g', ml: 'ml', unit: 'u' };

export const CATEGORY_LABELS = {
    cafeteria: 'Cafetería',
    cleaning: 'Limpieza',
    packaging: 'Packaging',
    other: 'Otros',
};

/**
 * Unidad en la que se pide la cantidad de un insumo.
 *
 * Un insumo con `package_size = 1` es de UN SOLO nivel (D-13): se gasta de a unidades
 * enteras y no tiene remanente, así que se pide en 'u' aunque su base_unit diga otra cosa.
 * Uno fraccionable se pide en su unidad base (g/ml).
 */
export function unitLabel(supply) {
    if (!supply) {
        return '';
    }
    return Number(supply.packageSize) > 1 ? (UNIT_LABELS[supply.baseUnit] || supply.baseUnit) : 'u';
}

export function categoryLabel(category) {
    return CATEGORY_LABELS[category] || category || 'Otros';
}
